<template>
    <el-container class="h-100">
        <el-header class="app-header p-5px" ref="header" style="height: 200px !important">
            <el-row
                :type="$client.width < 1000 ? null : 'flex'"
                :justify="$client.width < 1000 ? null : 'space-between'"
            >
                <div class="pull-left mr-1 line-height-40">
                    <span class="form-label">Translation Language</span>
                    <el-select v-model="selectedTranslation" placeholder="Language" size="mini">
                        <el-option
                            v-for="item in $store.getters.getLangs"
                            :key="item.languageCode"
                            :label="item.label"
                            :value="item.languageCode"
                        >
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="selectedType"
                        placeholder="Token Type"
                        size="mini"
                        class="filter-type"
                        clearable
                    >
                        <el-option
                            v-for="item in ['ui', 'backend', 'form']"
                            :key="item"
                            :label="item"
                            :value="item"
                        >
                        </el-option>
                    </el-select>
                    <el-button
                        type="default"
                        size="medium"
                        icon="fa fa-refresh"
                        style="padding: 5px"
                        @click="syncTokens()"
                    >
                        Sync latest tokens
                    </el-button>
                    <el-checkbox v-model="showNotTranslated"
                        >Display only not translated</el-checkbox
                    >
                </div>
                <div class="pull-right line-height-40">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="fa fa-refresh"
                        style="padding: 5px"
                        @click="getList()"
                    ></el-button>
                </div>
            </el-row>
        </el-header>
        <el-card shadow :body-style="{ padding: '5px' }">
            <el-table
                size="mini"
                class="token-table"
                style="width: 100%"
                :data="pagingList"
                ref="table"
                :max-height="tableMaxHeight - 32"
                v-loading="loading || list.loading"
            >
                <el-table-column header-align="left">
                    <template slot="header">
                        <div class="form-label">Token Type</div>
                    </template>
                    <template slot-scope="prop">
                        {{
                            prop.row.token_type != 'ui' && prop.row.token_type != 'backend'
                                ? 'form'
                                : prop.row.token_type
                        }}
                    </template>
                </el-table-column>

                <el-table-column header-align="left">
                    <template slot="header">
                        <div class="form-label">Token</div>
                        <div class="el-input el-input--mini w-20r">
                            <input
                                type="text"
                                class="el-input__inner"
                                placeholder="Token"
                                v-model="filterToken"
                                size="mini"
                            />
                        </div>
                    </template>
                    <template slot-scope="prop">
                        {{ prop.row.token }}
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot="header">
                        <div class="form-label">Translation</div>
                        <div class="el-input el-input--mini w-20r">
                            <input
                                type="text"
                                class="el-input__inner"
                                v-model="filterTranslation"
                                placeholder="Translation"
                                size="mini"
                            />
                        </div>
                    </template>
                    <template slot-scope="prop">
                        <el-input
                            :class="!prop.row.editing ? 'input-readonly' : ''"
                            v-model="prop.row.translation"
                            @focus="prop.row.editing = true"
                            @blur="onEditComplete(prop.row)"
                            type="textarea"
                            autosize
                            placeholder="Translation"
                            size="mini"
                        ></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="w-100 text-align-center"
                background
                layout="prev, pager, next"
                :page-size.sync="pageSize"
                :current-page.sync="pageNumber"
                :total="filteredList.length"
                hide-on-single-page
            >
            </el-pagination>
        </el-card>
    </el-container>
</template>

<script>
import axios from 'axios';
import Collection from '@/lib/data/Collection';
import Token from '@/data/Token';

export default {
    name: 'translation',
    data() {
        return {
            tableMaxHeight: 0,
            loading: false,
            list: new Collection({
                model: Token,
                url: '/translation/list',
                method: 'GET',
            }),
            selectedTranslation: 'en',
            filterToken: null,
            filterTranslation: null,
            pageSize: 50,
            pageNumber: 1,
            showNotTranslated: false,
            selectedType: null,
            // translationMap: {
            //     'en': 'English',
            //     'tr': 'Turkish',
            //     'ro': 'Romanian'
            // }
            // translationMap: this.$store.getters.getLangs
        };
    },
    created() {
        this.getList();
    },
    mounted() {
        this.resize();
    },
    computed: {
        // selectedTranslationText () {
        //     return this.translationMap[this.selectedTranslation] || 'English'
        // },
        filteredList() {
            let { list } = this;
            let { filterToken } = this;
            let { filterTranslation } = this;
            const filterType = this.selectedType;

            if (this.showNotTranslated) {
                list = list.filter((item) => !item.hasTranslation);
            }

            if (filterToken) {
                filterToken = filterToken.trim();
                list = list.filter((item) => new RegExp(`${filterToken}`, 'gi').test(item.token));
            }
            if (filterTranslation) {
                filterTranslation = filterTranslation.trim();
                list = list.filter((item) =>
                    new RegExp(`${filterTranslation}`, 'gi').test(item.translation)
                );
            }
            if (filterType) {
                list = list.filter((item) => {
                    if (filterType == 'form') {
                        return item.token_type != 'ui' && item.token_type != 'db';
                    }
                    return item.token_type == filterType;
                });
            }

            return list;
        },
        pagingList() {
            return this.filteredList.slice(
                (this.pageNumber - 1) * this.pageSize,
                this.pageNumber * this.pageSize
            );
        },
    },
    watch: {
        selectedTranslation() {
            this.getList();
        },
    },
    methods: {
        getList() {
            this.list.load(true, {
                params: {
                    language_code: this.selectedTranslation,
                },
            });
        },
        syncTokens() {
            this.loading = true;
            axios.get('/translation/analyze').then(() => {
                this.loading = false;
                this.getList();
            });
        },
        resize() {
            this.$nextTick(() => {
                const main = this.$el.parentElement;
                const header = this.$refs.header.$el;
                if (main) {
                    const mainHeight = main.clientHeight;
                    const headerHeight = header.clientHeight;
                    const padding = 20;

                    this.tableMaxHeight = mainHeight - (headerHeight + padding);
                }
            });
        },
        /* eslint-disable no-param-reassign */
        onEditComplete(token) {
            token.editing = false;
            if (token.translation) {
                token.updateTranslation({
                    success: () => {
                        token.commit();
                        token.success = true;
                    },
                });
            }
        },
        /* eslint-disable */
    },
};
</script>
<style lang="scss">
.token-table {
    .el-input.input-readonly input {
        border: 0;
        background: transparent;
    }
    textarea {
        line-height: 23px;
        font-size: 12px;
        font-family: inherit !important;
        resize: none;
        overflow: hidden;
        white-space: nowrap;
    }
    .input-readonly textarea {
        border: 0;
        background: transparent;
    }
    .filter-type {
        .el-input__suffix {
            right: 15px;
        }
    }
}
</style>
